import { nextRirValue } from "../domain/executionUi";

export default function ExecutionRirControl({
  value,
  targetRir,
  setIndex = null,
  disabled = false,
  compact = false,
  onCommit,
}) {
  const display = value == null
    ? targetRir == null ? "RIR" : String(targetRir)
    : value === 5 ? "5+" : String(value);
  // The spoken name separates a target ghost from an actual selection; the
  // visible value alone reads the same for both.
  const subject = setIndex == null ? "RIR" : `Set ${setIndex} RIR`;
  const state = value != null
    ? `${display} selected`
    : targetRir == null ? "not set" : `target ${targetRir}`;
  return (
    <div className="lz-workout-rir-control">
      <span className={compact ? "lz-v2-visually-hidden" : "lz-workout-field-label"} aria-hidden="true">RIR</span>
      <button
        type="button"
        disabled={disabled}
        data-actual-rir={value == null ? "" : value}
        onClick={() => onCommit(nextRirValue(value, targetRir))}
        aria-label={`${subject}, ${state}`}
      >
        <span className="lz-workout-rir-control__value">{display}</span>
      </button>
    </div>
  );
}
